import { Loader2 } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';

import { Button } from 'components/ui/button';
import { ScrollArea } from 'components/ui/scroll-area';
import { checkSpanishLocale, extractLabelAndComment } from 'lib/utils';
import { SymptomQuestion } from 'services/symptom-checker/type';
import { useTranslation } from 'react-i18next';

interface SymptomContainerProps {
  children: React.ReactNode;
  questionData: SymptomQuestion | undefined;
  onContinue: () => void;
  isLoading: boolean;
  disabled?: boolean;
  questionNumber: number;
  otherButton?: React.ReactNode;
}

export default function SymptomContainer({
  children,
  questionData,
  onContinue,
  isLoading,
  questionNumber,
  disabled = false,
  otherButton,
}: SymptomContainerProps) {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  const isSpanish = checkSpanishLocale();

  const { label } = extractLabelAndComment(
    questionData?.[isSpanish ? 'spanish_question' : 'eng_question'] ?? ''
  );
  return (
    <div>
      <ScrollArea className='h-fit lg:h-[calc(100vh-20.75rem)]'>
        <div className='flex-1 px-4 pt-4 pb-3'>
          <h2 className='text-base font-semibold md:text-lg'>
            {t('question')} #{questionNumber}
          </h2>

          <div className='mt-3'>
            <p className='mb-4 text-base font-semibold'>{label}</p>
            <div>{children}</div>
          </div>
        </div>
      </ScrollArea>
      <div className='flex items-center justify-center gap-3 mt-3'>
        <Button
          className='px-6 h-9'
          onClick={onContinue}
          disabled={isLoading || disabled}
        >
          {isLoading && <Loader2 className='mr-2 animate-spin size-4' />}
          {code ? t('update') : t('continue')}
        </Button>
        {otherButton ? <div>{otherButton}</div> : null}
      </div>
    </div>
  );
}
